import * as React from "react";
import { Link } from "react-router-dom";
import { CaseRunClient, ClientResources, QueriesClient, SentryCaseRunModel } from "@app/api2/api";
import { buildUrl, AppRoutes } from "../../../../AppRoutes";
import { BPColumn } from "@common/BPReactTable";
import { getRunStatusAsString, yesNo } from "@common/Utils";
import { BPDataTable3 } from "@app/components/React/Common/DataTable/BPDataTable3";

interface SentryCaseRunsProps {
    labId?: number;
    caseId?: number;
    referenceId?: number;
    canCreateEvidence: boolean;
}

export class SentryCaseRuns extends React.Component<SentryCaseRunsProps> {
    client: CaseRunClient = new CaseRunClient();
    queries: QueriesClient = new QueriesClient();
    translationsContext: React.Context<ClientResources>;

    constructor(props, context) {
        super(props, context);
        
    }

    render() {
        const columns: BPColumn<SentryCaseRunModel>[] = [
            {
                Header: "Id",
                accessor: 'id',
                disableSortBy: false,
                Cell: item => <Link to={buildUrl(AppRoutes.CaseRunDetails, {
                    caseId: item.row.original.caseId,
                    caseRunId: item.value,
                    labId: item.row.original.labId
                })}>{item.value}</Link>,
                width: "80px",
            },
            {
                Header: window.translation.common.population,
                accessor: 'populationName',
                disableSortBy: true,
                cellTitle: true,
                width: "200px",
            },
            ... (this.props.canCreateEvidence ? [
                {
                    Header: window.translation.common.evidence,
                    accessor: 'evidenceList',
                    disableSortBy: true,
                    cellTitle: true,
                    width: "200px",
                }] : []) as Array<BPColumn<SentryCaseRunModel>>,
            {
                Header: window.translation.common.referencePlural,
                accessor: 'referenceList',
                cellTitle: true,
                disableSortBy: true,
                width: this.props.canCreateEvidence ? "200px" : "400px",
            },
            {
                Header: window.translation.parameter.names.searchBetweenStains,
                accessor: 'searchBetweenStains',
                disableSortBy: true,
                width: '130px',
                Cell: item => <>{yesNo(item.value)}</>,
            },
            {
                Header: window.translation.common.hits,
                accessor: 'hitsCount',
                disableSortBy: false,
                width: "70px",
            },
            {
                Header: window.translation.common.status,
                accessor: 'status',
                disableSortBy: true,
                width: "100px",
                Cell: item => <>{getRunStatusAsString(item.value)}</>,
            },
        ];

        return (
            <BPDataTable3
                singleLine
                fixed
                defaultSortField="id"
                defaultSortAsc={false}
                enableSearch={true}
                dataSource={async (p) => {
                    // let pageData = await this.queries.getSentrySearchRuns(this.props.labId, this.props.caseId, p.perPage, p.page, p.sortBy, p.sortDirection);
                    let pageData = await this.queries.getSentrySearchRuns(this.props.labId, this.props.caseId, this.props.referenceId, false, p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue);
                    return pageData;
                }}
                columns={columns}
            />
        );
    }
}

